'use strict';

import angular from 'angular';
import ListController from './list.controller';

export default angular.module('updateServerApp.booklist.list', [])
  .controller('BookListController', ListController)
  .name;



// WEBPACK FOOTER //
// ./client/app/booklist/list/index.js